module.exports = __webpack_public_path__ + "media/ibra11-2.1ed7d4fa.mp3";